.wrapper {
	display: flex;
	flex-direction: column;
	gap: var(--size-3);
}

.header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: var(--size-3);
	min-height: var(--size-8);
}

.title {
	display: flex;
	align-items: center;
	gap: var(--size-3);
	font-size: var(--text-subtitle-2);
	font-weight: 500;
}

.description {
	margin: 0;
	font-size: var(--text-caption);
	color: var(--color-text-subtle);
}

.content {
	&:not([data-fullbleed="true"]) {
		padding: var(--size-5);
	}
}

.border {
	border: var(--size-border) solid var(--color-border);
	border-radius: var(--radius-lg);
}
